import React from "react";
import convert from "htmr";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import styled from "styled-components";
import Image from "../Image";

const ContainerStyled = styled(Container)`
  strong {
    font-weight: bold;
    color: rgb(50, 50, 50);
  }
`;

const transform = {
  img: node => <Image {...node} />,
  a: node => node.href ? <Link to={node.href} {...node} /> : "",
};

export default (props) => {
  const content = props?.text?.replace(/APP_NAME/g, process.env.REACT_APP_NAME);

  return (
    <ContainerStyled className={[`component--${props.name}`, props.class]} id={props.id}>
      {content && convert(content, { transform })}
    </ContainerStyled>
  )
};
